import React from 'react';

import { useSelector } from 'react-redux';
import { t } from 'react-switch-lang';
import ContactUsMaple from './ContactUsMaple';
import ContactUsPaySimply from './ContactUsPaySimply';
import ContactUsZenwallet from './ContactUsZenwallet';
import { DocumentTitle } from '../../../helperFunctions/DocumentTitle';
import { brandTitleGet } from '../../../configurations/Brands';
import NotFound from '../NotFound';
import ContactUsPartners from './ContactUsPartners';
import ContactUsPayments from './ContactUsPayments';

function ContactSorter() {
  const { brand, lang } = useSelector((state) => state);
  DocumentTitle(
    t('PageTitle_Brand_Contact').replace('xBrand', brandTitleGet(brand, lang))
  );
  const contactList = {
    paysimply: <ContactUsPaySimply lang={lang} />,
    zenwallet: <ContactUsZenwallet lang={lang} />,
    'canadapost-prepaid': <ContactUsMaple lang={lang} />,
    'canadapost-singleloadprepaid': <NotFound brand={brand} lang={lang} />,
    partners: <ContactUsPartners lang={lang} />,
    payments: <ContactUsPayments lang={lang} />,
  };

  return contactList[brand] || null;
}

export default ContactSorter;
